import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "p-grid p-m-0 p-fluid p-jc-center",
  "data-test": "metadata-form"
}
const _hoisted_2 = { class: "p-col-9" }
const _hoisted_3 = { class: "p-fluid p-m-5" }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = { class: "p-float-label" }
const _hoisted_15 = {
  for: "dataType",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0" }, {
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "kn-button p-button-text p-button-rounded",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.handleSubmit
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button p-button-text p-button-rounded",
          icon: "pi pi-times",
          onClick: _ctx.closeTemplate
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Card, null, {
          content: _withCtx(() => [
            _createVNode("form", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, [
                  _createVNode(_component_InputText, {
                    id: "label",
                    class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.metadata.label.$invalid && _ctx.v$.metadata.label.$dirty
                                    }],
                    type: "text",
                    modelValue: _ctx.v$.metadata.label.$model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.metadata.label.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.metadata.label.$touch())),
                    onChange: _ctx.setDirty,
                    "data-test": "label-input"
                  }, null, 8, ["modelValue", "class", "onChange"]),
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.metadata.label,
                  additionalTranslateParams: {
                                    fieldName: _ctx.$t('common.label')
                                }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("span", _hoisted_8, [
                  _createVNode(_component_InputText, {
                    id: "name",
                    class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.metadata.name.$invalid && _ctx.v$.metadata.name.$dirty
                                    }],
                    type: "text",
                    modelValue: _ctx.v$.metadata.name.$model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.metadata.name.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.metadata.name.$touch())),
                    onChange: _ctx.setDirty,
                    "data-test": "name-input"
                  }, null, 8, ["modelValue", "class", "onChange"]),
                  _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.metadata.name,
                  additionalTranslateParams: {
                                    fieldName: _ctx.$t('common.name')
                                }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("span", _hoisted_11, [
                  _createVNode(_component_InputText, {
                    id: "description",
                    class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.metadata.description.$invalid && _ctx.v$.metadata.description.$dirty
                                    }],
                    type: "text",
                    modelValue: _ctx.v$.metadata.description.$model,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.metadata.description.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.metadata.description.$touch())),
                    onChange: _ctx.setDirty,
                    "data-test": "description-input"
                  }, null, 8, ["modelValue", "class", "onChange"]),
                  _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.description')), 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.metadata.description,
                  additionalTranslateParams: {
                                    fieldName: _ctx.$t('common.description')
                                }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("span", _hoisted_14, [
                  _createVNode(_component_Dropdown, {
                    id: "dataType",
                    class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.metadata.dataType.$invalid && _ctx.v$.metadata.dataType.$dirty
                                    }],
                    modelValue: _ctx.v$.metadata.dataType.$model,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.metadata.dataType.$model = $event)),
                    options: _ctx.metadataTypes,
                    optionLabel: "name",
                    optionValue: "value",
                    onBeforeShow: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.metadata.dataType.$touch())),
                    onChange: _ctx.setDirty,
                    "data-test": "dataType-dropdown"
                  }, null, 8, ["class", "modelValue", "options", "onChange"]),
                  _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('common.type')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.metadata.dataType,
                  additionalTranslateParams: {
                                    fieldName: _ctx.$t('common.type')
                                }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}